export default {
  getViewHomeWork(state){
    return state.viewHomeWorks
  },
}



// WEBPACK FOOTER //
// ./src/store/axj_help/getters.js